import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// File-tree connectors: a continuous trunk with an elbow on the last child only (no per-item
// "├" ticks). Each NON-last row draws a single full-height vertical (`trunkSeg`) — stacked, these
// form one seamless trunk. The LAST row draws an elbow "└" (`elbow`): vertical top→centre +
// horizontal at centre, so the trunk visibly ends at the last item. Uniform 1px throughout.
export const styles = {
  sidebar: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kZKoxP: "x5yr21d",
    kAzted: "x2lwn1j",
    kWkggS: "xd9cxqr",
    kMv6JI: "xdv2sak",
    kWqL5O: "xs1s249",
    kSWEuD: "x32b0ac",
    k26BEO: "x14dkphh",
    kXHlph: "x6ikm8r",
    $$css: true
  },
  drawer: {
    kVAEAm: "xixxii4",
    k87sOh: "x13vifvy",
    kbCHJM: "xu96u03",
    krVfgx: "x1ey2m1c",
    kzqmXN: "x18qqrc1",
    kY2c9j: "x6y048q",
    k3aq6I: "x5i6ehr",
    kmkexE: "x1knesxh",
    $$css: true
  },
  drawerOpen: {
    k3aq6I: "xbryuvx",
    $$css: true
  },
  brand: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kmVPX3: "x4lad58",
    kmuXW: "x2lah0s",
    kybGjl: "x1hl2dhg",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  navFilter: {
    kmVPX3: "x14whr0k",
    kmuXW: "x2lah0s",
    $$css: true
  },
  brandCentered: {
    kjj79g: "xl56j7k",
    kg3NbH: "xnjsko4",
    $$css: true
  },
  brandMark: {
    kzqmXN: "x1td3qas",
    kZKoxP: "x10w6t97",
    kaIpWk: "xhpnuu7",
    kmuXW: "x2lah0s",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kMwMTN: "x1m3rtoy",
    kKwaWg: "x1w4ef1l",
    kGVxlE: "x1w71hzg",
    $$css: true
  },
  brandName: {
    kMv6JI: "xpc6l4x",
    k63SB2: "xtpl1r7",
    kGuDYH: "x1edk5ry",
    kb6lSQ: "x16q24ku",
    kMwMTN: "x1oezkus",
    kLWn49: "x1159mfc",
    $$css: true
  },
  brandAccent: {
    kMwMTN: "x1459q0w",
    $$css: true
  },
  brandSub: {
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    kb6lSQ: "x9pfba7",
    kP9fke: "xtvhhri",
    keoZOQ: "xvijh9v",
    $$css: true
  },
  nav: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1jl4kzi",
    kmVPX3: "xgx5ihr",
    kUk6DE: "x98rzlu",
    kORKVm: "x1odjw0f",
    kXHlph: "x6ikm8r",
    $$css: true
  },
  navRail: {
    kGNEyG: "x6s0dn4",
    kOIVth: "xr8clws",
    $$css: true
  },
  navSec: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  navGroup: {
    kGuDYH: "x34ze3o",
    kb6lSQ: "x1vyo3qp",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    k63SB2: "xomqrzn",
    kLWn49: "xtqwzw6",
    kmVPX3: "x1ls0ypc",
    $$css: true
  },
  navSecBody: {
    kVAEAm: "x1n2onr6",
    koQZXg: "x1vmvo6x",
    $$css: true
  },
  groupBtn: {
    kzqmXN: "xh8yej3",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    k9WMMc: "xdpxx8g",
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  treeRow: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    k8WAf4: "x1m7iz9m",
    kg3NbH: "xy65nll",
    kLWn49: "xtqwzw6",
    kaIpWk: "xxltkoq",
    kkrTdU: "x1ypdohk",
    kybGjl: "x1hl2dhg",
    khDVqt: "xuxw1ft",
    kVAEAm: "x1n2onr6",
    k63SB2: "xssbmp7",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xitfd3n",
    kmkexE: "x1wjv31i",
    kGzVvX: "x1ie750n",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  treeRowActive: {
    kWkggS: "x1wtxg5f",
    kMwMTN: "xmge4x3",
    kGzVvX: "x106t4ra",
    kDPRdz: "xpajm5y",
    $$css: true
  },
  connector: {
    kE3dHu: "xl5cg90",
    $$css: true
  },
  trunkSeg: {
    kgeoSG: "x1cpjm7i",
    kEoFBp: "x1hmns74",
    k75S9Q: "x1wlytlt",
    k96MEf: "x1y3wzot",
    k5Ofw7: "xhq5o37",
    kOlAkY: "x1vgi0k",
    kLkRvE: "x1essei3",
    $$css: true
  },
  elbow: {
    kgeoSG: "x1cpjm7i",
    kEoFBp: "x1hmns74",
    k75S9Q: "x1wlytlt",
    k96MEf: "x1y3wzot",
    kOlAkY: "xaknh5y",
    kgzTxl: "xdahmmw",
    kUmSqE: "x23x4mj",
    ktumvE: "xrreuzn",
    k6d8aP: "xkaxd4b",
    kTJRYx: "xu20p9z",
    kjBTDo: "x1opv7go",
    k1cwP5: "x1s8o88i",
    $$css: true
  },
  subText: {
    kGuDYH: "x2pyw9z",
    kOIVth: "x1mnnc3i",
    $$css: true
  },
  navIcon: {
    kmuXW: "x2lah0s",
    kzqmXN: "x1xp8n7a",
    kZKoxP: "xmix8c7",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kSiTet: "x1us6l5c",
    kMwMTN: "x15rks2t",
    $$css: true
  },
  navIconActive: {
    kSiTet: "x1hc1fzr",
    $$css: true
  },
  navLabel: {
    kUk6DE: "x98rzlu",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    $$css: true
  },
  navBadge: {
    kmuXW: "x2lah0s",
    k7Eaqz: "x16xo4sp",
    kg3NbH: "xm9j1uf",
    kaIpWk: "xoy5co8",
    kWkggS: "x4qlrbh",
    kMwMTN: "xahmsqx",
    kGuDYH: "x34ze3o",
    k63SB2: "xomqrzn",
    kLWn49: "xuy8w9f",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  railBadgeDot: {
    kVAEAm: "x10l6tqk",
    k87sOh: "x1atx4j1",
    kCIrl2: "xclnmbr",
    kzqmXN: "x1xc55vz",
    kZKoxP: "xdk7pt",
    kaIpWk: "xoy5co8",
    kWkggS: "x4qlrbh",
    kMzoRj: "xdh2fpr",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x8weufq",
    $$css: true
  },
  railItemRelative: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  navParent: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  navParentTrunk: {
    kgeoSG: "x1cpjm7i",
    kEoFBp: "x1hmns74",
    k75S9Q: "x1wlytlt",
    k96MEf: "x1y3wzot",
    k5Ofw7: "xhq5o37",
    kOlAkY: "x1vgi0k",
    kLkRvE: "x1essei3",
    $$css: true
  },
  chev: {
    koQZXg: "x8x9d4c",
    kzqmXN: "x1a00udw",
    kZKoxP: "xx3o462",
    kMwMTN: "xdxw5r1",
    kmkexE: "x1knesxh",
    $$css: true
  },
  chevOpen: {
    k3aq6I: "x1iffjtl",
    $$css: true
  },
  navSub: {
    kVAEAm: "x1n2onr6",
    koQZXg: "x1b50yj1",
    kVQacm: "xb3r6kr",
    kskxy: "xnjgh8c",
    kmkexE: "xqrz33g",
    $$css: true
  },
  navSubOpen: {
    kskxy: "x1sslpiy",
    $$css: true
  },
  railItem: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kzqmXN: "x100vrsf",
    kZKoxP: "x1vqgdyp",
    kaIpWk: "xxltkoq",
    kMwMTN: "xitfd3n",
    kybGjl: "x1hl2dhg",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1wjv31i",
    kGzVvX: "x1ie750n",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  railTooltip: {
    kVAEAm: "xixxii4",
    kY2c9j: "x1aciyhk",
    k8WAf4: "x1y66j1o",
    kg3NbH: "x1g3f1de",
    kaIpWk: "x1d0dq8e",
    kWkggS: "x1gq67uk",
    kMwMTN: "x13w1leu",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kLWn49: "xtqwzw6",
    khDVqt: "xuxw1ft",
    kfzvcC: "x47corl",
    kGVxlE: "x7g3v46",
    $$css: true
  },
  railItemActive: {
    kWkggS: "x1wtxg5f",
    kMwMTN: "xmge4x3",
    $$css: true
  },
  railButton: {
    kmuXW: "x2lah0s",
    ksu8eU: "xng3xce",
    kmVPX3: "x1717udv",
    kMv6JI: "xjb2p0i",
    kWkggS: "xjbqb8w x1ie750n",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    $$css: true
  },
  railFlyout: {
    kVAEAm: "xixxii4",
    kY2c9j: "x1aciyhk",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x195vfkc",
    k7Eaqz: "x12rczxh",
    ks0D6T: "xw5ewwj",
    kORKVm: "x1odjw0f",
    kmVPX3: "xrqf348",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1dx90e9",
    kaIpWk: "xxltkoq",
    kWkggS: "xd9cxqr",
    kGVxlE: "x7g3v46",
    kMv6JI: "xdv2sak",
    $$css: true
  },
  railFlyoutTitle: {
    kmVPX3: "x26wehj",
    $$css: true
  },
  railFlyoutGroup: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    k8WAf4: "xknfcqp",
    kg3NbH: "xy65nll",
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kLWn49: "xtqwzw6",
    kMwMTN: "xdxw5r1",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  railFlyoutIndent: {
    kE3dHu: "x12di60e",
    $$css: true
  }
};